/* import __COLOCATED_TEMPLATE__ from './phone-handover.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type Store from '@ember-data/store';
import type FinVoiceConfigService from 'embercom/services/fin-voice-config-service';
import type {
  HandoverConfiguration,
  FinVoiceNumberConfigurationHandoverConfiguration,
  HandoverConfigurationTools,
} from 'embercom/models/fin-voice/number-configuration';
import type FinVoiceNumberConfiguration from 'embercom/models/fin-voice/number-configuration';
import type { ScheduledConfigurationKey } from 'embercom/models/fin-voice/number-configuration';
interface Args {
  accordion: $TSFixMe;
  ruleset: $TSFixMe;
  phoneNumberId?: string;
  numberConfiguration?: FinVoiceNumberConfiguration;
  updateHandover: (handoverConfig: FinVoiceNumberConfigurationHandoverConfiguration) => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class PhoneHandover extends Component<Signature> {
  @service declare appService: AppService;
  @service declare store: Store;
  @service declare intl: IntlService;
  @service declare finVoiceConfigService: FinVoiceConfigService;
  @service declare notificationsService: $TSFixMe;

  get scheduledConfigurationKeys(): ScheduledConfigurationKey[] {
    return ['default', 'in', 'nin'];
  }

  get numberConfiguration() {
    return this.args.numberConfiguration;
  }

  get hasMultipleHandoverConfigs() {
    return Object.keys(this.numberConfiguration?.handoverConfiguration || {}).length > 1;
  }

  get openSectionId() {
    return this.args.accordion.accordionAPI.openSectionId;
  }

  get hasHandoverConfig() {
    return Object.keys(this.numberConfiguration?.handoverConfiguration || {}).length > 0;
  }

  @action
  getHandoverIcon(type?: ScheduledConfigurationKey) {
    switch (type) {
      case 'nin':
        return 'globe';
      case 'in':
        return 'star';
      case 'default':
        return 'plus';
    }

    return 'new';
  }

  @action
  getHeadingLabel(type?: HandoverConfigurationTools) {
    if (type) {
      return this.intl.t(
        `operator.fin.setup.tabs.setup-and-go-live.phone.handover-escalation.action-${type}`,
      );
    }

    return '';
  }

  @action
  getHandoverSummary(_: string, value?: HandoverConfiguration) {
    if (!value) {
      return '';
    }

    if (value.type === 'handover-to-voicemail' || value.type === 'handover-to-human') {
      let assigneeId = value.config.assigneeId;
      return this.appService.app.assignableAdmins.findBy('id', assigneeId)?.name;
    }

    return '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::NumberConfiguration::PhoneHandover': typeof PhoneHandover;
  }
}
